export default {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0
  },
  imgContainer: {
    display: 'flex',
    minHeight: ['333px', '333px', '512px', '512px', '520px'],
    position: 'relative',
    padding: 0
  },
  image: (breakpoint: string) => {
    const displayMap = {
      desktop: ['none', 'none', 'none', 'none', 'block', 'block', 'block'],
      tablet: ['block', 'none', 'none', 'block', 'none'],
      mobile: ['none', 'block', 'block', 'none']
    };
    return {
      position: 'relative',
      objectFit: 'cover',
      display: displayMap[breakpoint]
    };
  },
  header: {
    mt: ['32px', '32px', '32px', '66px'],
    mb: '0',
    mx: ['32px', '16px', '16px', '0'],
    wordWrap: 'break-word',
    wordBreak: 'break-word'
  }
};